export default __webpack_public_path__ + "static/media/mauquenchy.cb373b06.jpg";